import { useEffect } from 'react'
import PropTypes from 'prop-types'
import { resetAuthState } from '../actions'
import { useAuthState } from '../context'
import useUserManager from '../useUserManager'
import { revokeUserTokens } from '../createUserManager'

function Logout({ render }) {
    const [, dispatch] = useAuthState()
    const userManager = useUserManager()

    useEffect(() => {
        const signOut = async () => {
            // Use shared token revocation function (idempotent, safe to call multiple times)
            // Also clears master password from session storage
            await revokeUserTokens()

            dispatch(resetAuthState())
            userManager.signoutRedirect()
        }
        signOut()
    }, [dispatch, userManager])

    return render()
}

Logout.propTypes = {
    render: PropTypes.func.isRequired,
}

export default Logout
